module.exports = __webpack_public_path__ + "static/media/ios_appstore.02698cc0.jpg";